module.exports = __webpack_public_path__ + "static/shadows-3af50f85de424c6c11381157ae215c2f.png";